import { __rest } from "tslib";
import React from 'react';
import { RicosViewer } from 'ricos-viewer-next';
import { runStrategies, extractPluginsConfig, fetchEmbedData, themeStrategy, experimentStrategy, } from '@wix/ricos-common';
import { merge } from 'lodash';
import { runViewerStrategies } from './runViewerStrategies';
const WixRicosViewer = props => {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { version: wixRicosVersion } = require('../../package.json');
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const { version: ricosVersion } = require('ricos-viewer-next/package.json');
    const { children, biSettings, instance, plugins, theme, wixExperiments, allowLinkPreviewPopover, httpClient, msid, baseUrl, previewMode, content } = props, rest = __rest(props, ["children", "biSettings", "instance", "plugins", "theme", "wixExperiments", "allowLinkPreviewPopover", "httpClient", "msid", "baseUrl", "previewMode", "content"]);
    const experiments = experimentStrategy(wixExperiments);
    const strategyProps = runStrategies({
        plugins,
        instance,
        biSettings,
        experiments,
        wixRicosVersion,
        ricosVersion,
        httpClient,
        msid,
        viewer: true,
        content,
    });
    const _rcProps = merge(strategyProps, runViewerStrategies(plugins, baseUrl, previewMode), extractPluginsConfig(plugins, strategyProps.helpers));
    return (React.createElement(RicosViewer, Object.assign({ _rcProps: _rcProps, content: content, experiments: strategyProps.experiments, plugins: plugins, theme: themeStrategy(theme) }, (allowLinkPreviewPopover && {
        linkPreviewPopoverFetchData: fetchEmbedData(instance),
    }), rest), children));
};
export default WixRicosViewer;
//# sourceMappingURL=WixRicosViewerNext.js.map